export const timeConversion = (date) => {

  let millisec = Math.abs(new Date() - date)

  let seconds = (millisec / 1000).toFixed(1);

  let minutes = (millisec / (1000 * 60)).toFixed(1);

  let hours = (millisec / (1000 * 60 * 60)).toFixed(1);

  let days = (millisec / (1000 * 60 * 60 * 24)).toFixed(1);

  if (seconds < 60) {
      return seconds + " Sec";
  } else if (minutes < 60) {
      return minutes + " Min";
  } else if (hours < 24) {
      return hours + " Hrs";
  } else {
      return days + " Days"
  }
}